import React, { useState } from "react";
import { ReactComponent as FilterIcon } from "assets/img/icons/filterIcon.svg";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useTeamContext } from "store/contexts/teamContext";
import MultipleSelector from "components/MultipleSelector";
import DatePicker from "components/DatePicker";
import { ReactComponent as DateIcon } from "assets/img/icons/dateIcon.svg";
import Button from "components/CustomButton";
import classNames from "classnames";
import * as moment from "moment";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import Loader from "components/Loader";

export default () => {
  const [showDailog, setShowDailog] = useState(false);
  const dispatch = useDispatch();
  const { allTimelinePost, sortData, setFilters, filters } =
    useTeamActionContext();
  const [loading, setLoading] = useState(false);
  const [dateTo, setDateTo] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  // const [filterData, setFilterData] = useState({
  //   type_id: [],
  //   selectMembers: [],
  //   taggedMembers: [],
  //   date_from: null,
  //   date_to: null,
  // });
  const { team } = useTeamContext();
  const [postTypes] = useState([
    {
      value: "Status",
      id: 1,
    },
    {
      value: "Wall of Fame",
      id: 8,
    },
    {
      value: "Bright Idea",
      id: 9,
    },
    {
      value: "Check-in",
      id: 5,
    },
    {
      value: "Team Video",
      id: 11,
    },
    {
      value: "Slide Show",
      id: 6,
    },
    {
      value: "Topic",
      id: 10,
    },
  ]);
  const loaderStyle = {
    width: "100%",
    height: "100%",
  };

  const handleType = (id) => {
    if (filters.type_id.indexOf(id) >= 0) {
      setFilters({
        ...filters,
        type_id: filters.type_id.filter((typeId) => typeId !== id),
      });
      return;
    }

    setFilters({
      ...filters,
      type_id: [...filters.type_id, id],
    });
  };

  const handleStartDate = (date) => {
    var startDate = date;

    setDateFrom(startDate);
    setFilters({
      ...filters,
      date_from: moment(startDate).format("YYYY-MM-DD"),
    });
  };

  const handleEndDate = (date) => {
    var endDate = date;

    setDateTo(endDate);
    setFilters({
      ...filters,
      date_to: moment(endDate).format("YYYY-MM-DD"),
    });
  };

  const handleSubmit = async () => {
    // if (JSON.stringify(filters) === JSON.stringify(filters)) {
    //   setShowDailog(false);
    //   return;
    // }

    try {
      setLoading(true);

      await Promise.all([
        dispatch(timelineActions.clearAll()),
        allTimelinePost(1, sortData, filters),
      ]);

      setFilters(filters);
      setShowDailog(false);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const resetFilter = () => {
    setFilters({
      type_id: [],
      selectMembers: [],
      taggedMembers: [],
      date_from: null,
      date_to: null,
    });

    setDateFrom(null);
    setDateTo(null);
  };

  return (
    <>
      <div
        className={classNames({
          sortSvg: true,
          sortsvgActive:
            filters.date_from ||
            filters.date_to ||
            filters.selectMembers.length !== 0 ||
            filters.taggedMembers.length !== 0 ||
            filters.type_id.length !== 0
              ? true
              : false,
        })}
        onClick={() => setShowDailog(true)}
      >
        <FilterIcon className="svg" />
      </div>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{ modal: "filterModal" }}
        center
        open={showDailog}
        showCloseIcon={false}
        onClose={() => setShowDailog(false)}
      >
        <div className="filterHeading">
          <span className="fheaderName">Filters</span>
          <CancelIcon
            onClick={() => setShowDailog(false)}
            className="cancelIcon"
          />
        </div>
        <div className="filterContent">
          <span className="resetFilter" onClick={resetFilter}>
            Reset/Clear
          </span>
          <div>
            <div className="postTypeHeading">Post Types</div>
            <div className="typeOption">
              {postTypes.map((type) => (
                <span
                  className={classNames({
                    selectTypeOption:
                      filters.type_id.indexOf(type?.id) >= 0 ? true : false,
                  })}
                  key={type.id}
                  onClick={() => handleType(type.id)}
                >
                  {type.value}
                </span>
              ))}
            </div>
          </div>
          <div>
            <div className="postTypeHeading">Members</div>
            <MultipleSelector
              members={team.users}
              selectMembers={filters.selectMembers}
              filterData={filters}
              setSelectMembers={setFilters}
              fieldName="selectMembers"
            />
          </div>
          <div>
            <div className="postTypeHeading">Tagged Members</div>
            <MultipleSelector
              members={team.users}
              selectMembers={filters.taggedMembers}
              filterData={filters}
              setSelectMembers={setFilters}
              fieldName="taggedMembers"
            />
          </div>
          <div className="fdateContainer">
            <div>
              <div className="postTypeHeading dateHeading">Date From</div>
              <DatePicker
                endIcon={<DateIcon className="filterTimeSvg" />}
                preventOpenOnFocus={true}
                inputClass={"form-control fdateBorder"}
                value={dateFrom}
                onChange={(date) => handleStartDate(date)}
                startDate={dateFrom}
                endDate={dateTo}
                selectDate={"selectsStart"}
                dateFormat="MMM, d, yyyy"
                maxDate={
                  dateTo
                    ? moment(dateTo).subtract(1, "days").toDate()
                    : moment().toDate()
                }
              />
            </div>
            <div>
              <div className="postTypeHeading dateHeading">Date To</div>
              <DatePicker
                preventOpenOnFocus={true}
                endIcon={<DateIcon className="filterTimeSvg" />}
                inputClass={"form-control fdateBorder"}
                onChange={(date) => handleEndDate(date)}
                value={dateTo}
                selectDate={"selectsEnd"}
                dateFormat="MMM, d, yyyy"
                startDate={dateFrom}
                endDate={dateTo}
                minDate={moment(dateFrom).toDate()}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
        </div>
        <div className="filterFooter">
          <Button
            buttonClass={"filterButton grad_btn full_w"}
            disabled={loading && true}
            onClick={handleSubmit}
          >
            {loading ? (
              <div style={loaderStyle}>
                <Loader width={20} height={20} />
              </div>
            ) : (
              "Apply"
            )}
          </Button>
        </div>
      </Modal>
    </>
  );
};
